import React, { useState, useMemo, useCallback } from "react";
import { Logout } from "../helper/user/auth";
import { Link } from "react-router-dom";
import { Dropdown } from "antd";
import { Fileurl } from "../config/url";

const LogOutDetails = ({ user }) => {
  const [load, setLoad] = useState(false);

  const handleLogout = useCallback(() => {
    Logout();
  }, []);

  // Memoize user data to prevent losing it during re-renders
  const userData = useMemo(() => {
    if (!user || typeof user !== "object") {
      return null;
    }
    return user;
  }, [user]);

  const menu = useMemo(() => {
    if (!userData) {
      return (
        <div className="bg-white p-4 max-w-full w-[300px] rounded-md shadow-md">
          <div className="text-center">
            <p className="text-gray-400">Loading user data...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="bg-white p-4 max-w-full w-[300px] rounded-md shadow-md">
        <div className="text-center">
          <img
            src={
              userData?.users_profile_details?.length > 0
                ? Fileurl + userData?.users_profile_details[0].data
                : ""
            }
            className="mx-auto mb-4 h-[150px]"
            alt=""
          />
        </div>

        {!load && (
          <div className="unload text-center">
            <h2 className="text-xl font-bold">
              {userData?.name ? userData?.name : "N/A"}
            </h2>
            <p className="text-black mb-4">
              {userData?.employee_id ? userData?.employee_id : "N/A"}
            </p>

            <p className="text-gray-400 mb-4">
              {userData?.email ? userData?.email : "N/A"}
            </p>

            <div className="flex justify-center items-center mt-5">
              <Link
                className="font-bold"
                onClick={() => {
                  setLoad(true);
                }}
              >
                Details
              </Link>
              <span className="inline-block mx-4">|</span>
              <Link to="/site-manager/login" onClick={handleLogout}>
                Sign Out
              </Link>
            </div>
          </div>
        )}

        {load && (
          <div className="loaded">
            <h2 className="text-xl font-bold">
              {userData?.name ? userData?.name : "N/A"}
            </h2>
            <p className="text-gray-400 mb-4">
              {userData?.email ? userData?.email : "N/A"}
            </p>

            <p className="text-gray-400">Card ID</p>
            <p className="text-black mb-4">
              {userData?.employee_id ? userData?.employee_id : "N/A"}
            </p>

            <p className="text-gray-400">Employed As</p>
            <p className="text-black mb-4">{userData?.role || "N/A"}</p>

            <p className="text-gray-400">Phone Number</p>
            <p className="text-black mb-4">
              {userData?.mobile ? userData?.mobile : "-"}
            </p>

            <p className="text-gray-400">Address</p>
            <p className="text-black mb-4">
              {userData?.address ? userData?.address : "-"}
            </p>

            <div className="flex justify-center items-center mt-5">
              <Link to="/site-manager/login" onClick={handleLogout}>
                Sign Out
              </Link>
            </div>
          </div>
        )}
      </div>
    );
  }, [userData, load, handleLogout]);

  const profileImageSrc = useMemo(() => {
    if (!userData?.users_profile_details?.length) {
      return "";
    }
    return Fileurl + userData.users_profile_details[0].data;
  }, [userData]);

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
      <div className="rounded-full h-[35px] w-[35px] flex ml-5 border cursor-pointer">
        <img
          src={profileImageSrc}
          className="rounded-full"
          alt=""
          onClick={() => {
            setLoad(false);
          }}
        />
      </div>
    </Dropdown>
  );
};
export default LogOutDetails;
